import { useState } from 'react';

import {
  Heading,
  Text,
  Grid,
  TabList,
  Tab,
  useTheme,
} from '@simplywallst/ui-core';

import type { CountryISO } from '@/constants/countries';

import Tooltip from '@/components/Tooltip';

import { Chart } from '@/components/PortfolioPerformaceChart';
import type { PerformancePeriod } from '@/components/PortfolioPerformaceChart/types';

import { InformationIcon, TooltipTextWrapper, TabWrapper } from './styled';

const period: PerformancePeriod[] = ['7D', '1M', '3M', 'YTD', '1Y'];

interface Props {
  market: CountryISO;
  portfolioId: string;
}

export const Performance = ({ market, portfolioId }: Props) => {
  const theme = useTheme();
  const [state, setState] = useState<PerformancePeriod>('1Y');
  return (
    <Grid
      as="section"
      gap="8px"
      gapLg="4px"
      templateColumns="auto"
      templateColumnsMd="auto 248px"
      templateRows="max-content min-content min-content"
      templateRowsMd="max-content min-content"
    >
      <Grid gap="4px" templateColumns="max-content min-content">
        <Heading
          as="h2"
          typography="baseStrong"
          opacity={0.5}
          color="whiteRGBA"
        >
          Performance vs market
        </Heading>
        <Tooltip
          title={
            <TooltipTextWrapper gap="8px">
              <Text typography="tiny" color="spaceGray">
                The chart compares the performance of your current holdings to
                the broader market over a specific period of time.
              </Text>
              <Text typography="tiny" color="spaceGray">
                This metric helps you understand how well the companies you hold
                have performed compared to the overall market.
              </Text>
            </TooltipTextWrapper>
          }
          light
          placement="top"
          zIndex={99999}
        >
          <Grid>
            <InformationIcon fill={theme.color.whiteRGBA(0.5)} />
          </Grid>
        </Tooltip>
      </Grid>
      <TabWrapper row="3" rowMd="1" column="span 2" columnMd="2">
        <TabList templateColumns="auto auto auto auto auto">
          {period.map((n) => (
            <Tab
              key={`period-tab-${n}`}
              styleType="period"
              selected={state === n}
              onClick={() => setState(n)}
              value={n}
            >
              {n}
            </Tab>
          ))}
        </TabList>
      </TabWrapper>
      <Grid column="span 2" row="2">
        <Chart market={market} portfolioId={portfolioId} period={state} />
      </Grid>
    </Grid>
  );
};
